<div
  class="rounded-lg gap-1 w-fit min-w-48 flex flex-col px-4 py-3 bg-black/5 hover:bg-black/10 transition-all cursor-pointer box-border"
  [ngClass]="{ '!bg-accent-600/10': active }"
>
  <span>
    {{ label }}<br />
    <p>{{ title }}</p>
  </span>
  <h1 class="flex gap-2">
    {{ value | number }}
    @if (trend) {
      <div
        class="flex items-center gap-1 font-bold text-base"
        [ngClass]="{
          'text-red-600': trend < 0,
          'text-green-600': trend > 0
        }"
      >
        <span class="material-symbols-rounded text-base !w-4 text-inherit">{{
          trend > 0 ? 'trending_up' : 'trending_down'
        }}</span>
        {{ trend | number }}
      </div>
    }
  </h1>
</div>
